module.exports = __webpack_public_path__ + "img/logo_.23293ea0.png";